import { defineAsyncComponent } from 'vue'
export default {
  external: defineAsyncComponent(() => import("/home/runner/work/dashboard/dashboard/layouts/external.vue").then(m => m.default || m)),
  sidebar: defineAsyncComponent(() => import("/home/runner/work/dashboard/dashboard/layouts/sidebar.vue").then(m => m.default || m)),
  "terminal-redeem": defineAsyncComponent(() => import("/home/runner/work/dashboard/dashboard/layouts/terminal-redeem.vue").then(m => m.default || m)),
  "terminal-sell": defineAsyncComponent(() => import("/home/runner/work/dashboard/dashboard/layouts/terminal-sell.vue").then(m => m.default || m))
}